import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import CompanyInfo from 'view/companyInfo';

const CompanyInfoPage = () => {
	return (
		<PageTemplate>
			<CompanyInfo /> 
		</PageTemplate>
	);
};

export default CompanyInfoPage;

 